import { setCookie } from "@rokid/utils";
import { rokidAccountBaseUrl } from "@rokid/host";

// rokid账号退出登录
export const logoutOfRokid = () => {
  // 清除rokid账号cookie
  setCookie("ROKID_ACCOUNT_SESSION", "", -1, "rokid.com");
};

// rokid 跳转至账号中心
export const redirectToRokidAccountCenter = (redirectPath?: string) => {
  // 如果没有重定向路径，跳转账号中心
  if (!redirectPath) {
    window.location.href = rokidAccountBaseUrl;
  }
  // 否则跳转登录页
  else {
    window.location.href =
      window.location.href = `${rokidAccountBaseUrl}/login?redirect=${encodeURIComponent(
        redirectPath
      )}`;
  }
};

//
